'use client'

import { TextLink as TextLinkComponent } from '@circlefin/components/lib/TextLink'

export const TextLink = TextLinkComponent.Link
